import axios from "axios";
import { normaliseShopifyCustomerUrl } from "./shopifyDomains";

// Use a relative /api base so the same build works on any domain —
// preview, staging, or production (www.amdecorsignsandprints.co.uk).
// The Kubernetes ingress routes /api/* to the backend regardless of host.
const API = "/api";

export async function fetchProducts(params = {}) {
  const { data } = await axios.get(`${API}/shopify/products`, { params });
  return data;
}

export async function fetchProduct(handle) {
  const { data } = await axios.get(`${API}/shopify/products/${handle}`);
  return data;
}

export async function fetchCollections() {
  const { data } = await axios.get(`${API}/shopify/collections`);
  return data;
}

export async function fetchCollection(handle, params = {}) {
  const { data } = await axios.get(`${API}/shopify/collections/${handle}`, { params });
  return data;
}

export async function submitQuote(formData) {
  const { data } = await axios.post(`${API}/quotes`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function createShopifyCart({ variantId, quantity = 1, handle = "", note = "" }) {
  const { data } = await axios.post(`${API}/shopify/create-cart`, {
    variant_id: variantId,
    quantity,
    handle,
    note,
  });
  // Normalise any customer-facing URLs so they never hit the internal
  // *.myshopify.com hostnames — see lib/shopifyDomains.js.
  return {
    ...data,
    checkout_url: normaliseShopifyCustomerUrl(data?.checkout_url),
    fallback_url: normaliseShopifyCustomerUrl(data?.fallback_url),
  };
}

export async function checkHealth() {
  const { data } = await axios.get(`${API}/health`);
  return data;
}
